<template>
  <div class="homeContanier">
    <h3 class="pagename">留言</h3>
    <!-- <div class="search">
      <div>
        <label for="">受理状态:</label>
        <el-select v-model="value" placeholder="请选择" name="search">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="button-box">
        <el-button type="primary">查询</el-button>
      </div>

    </div> -->
    <div class="tips">总条目数量：{{allMassage.total}}</div>
    <div class="table-box">
      <div>
        <el-button @click="deleteAllMessage">批量删除</el-button>
      </div>
      <el-table ref="multipleTable" :data="customerMessage" @selection-change="SelectionChange" tooltip-effect="dark" style="width: 100%" class="from">
        <el-table-column type="selection" width="55" @selection-change="SelectionChange">
        </el-table-column>
        <el-table-column prop="name" label="姓名" >
        </el-table-column>
        <el-table-column prop="phone" label="电话" >
        </el-table-column>
        <el-table-column prop="email" label="邮箱" >
        </el-table-column>
        <el-table-column prop="demandContent" label="需求内容" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="handle" label="受理状态"  show-overflow-tooltip>
          <template slot-scope="scope">
            <div :style="{color:(scope.row.handle==0?'#f00':'#000')}">{{scope.row.handle|handle}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="updated_at" label="提交时间" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="操作" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-button :type="scope.row.handle|Buttoncol" :disabled="scope.row.handle|ButtonFun" @click='change(scope.row)'>{{dispose}}</el-button>
            <el-button type="danger" @click="deleteMessage(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background layout="prev, pager, next" :total="allMassage.total_pages*10" @current-change="currentPage">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Massge",
    //把需求处理为文字
    // 加载时判断是否有数据传入如果传入则将遮罩层取消
    data() {
      return {
        options: [{
          value: '选项1',
          label: '全部'
        }, {
          value: '选项2',
          label: '已处理'
        },
        {
          value: '选项3',
          label: '未处理'
        }
        ],
        value: "",
        //  客户需求列表的数据
        customerMessage: [],
        //客户需求的汇总信息
        allMassage:{},
        // 处理操作
        dispose: '处理',
        //受理状态
        massagestate: [1, 2, 3, 4],
        //表格数据
        multipleSelection: [],
        //需要处理的消息
        ids:[],
        //用户当前浏览的页码
        pagenumber:''
      }

    },
    // 处理状态的过滤器
    filters: {
      handle(type) {
        return type == 0 ? "未处理" : "已处理";
      },
      //处理按钮颜色的过滤器
      Buttoncol(val) {
        return val == 0 ? "primary" : "info";
      },
      //处理按钮功能的过滤器
      ButtonFun(val) {
        return val == 0 ? false : true;
      }
    },
    mounted() {
      this.getMassage()
    },
    methods: {
      //获取用户需求列表
      getMassage() {
        this.$getToken.get(this.$API.getDemands).then(res=>{
          this.customerMessage=res.data.data
          this.allMassage=res.data.meta.pagination
          console.log(res.data.data)
        }).catch(err=>{console.log(err)})
      },
      //用户筛选需求
      SelectionChange(val){
        this.ids=[]//初始化数据
        for(var i in val){
          this.ids.push(val[i].id)
        }
      },
      //改变页数
      currentPage(val){
        this.pagenumber=val
        this.$getToken.get(this.$API.getDemands, {
                    params: {
                        page: val
                    }
                }).then(res => {
                    this.customerMessage = res.data.data
                    this.allMassage=res.data.meta.pagination
                }).catch(err => { this.$message.error("服务器开了小差，请刷新重试") })
      },
      //处理需求
      change(val){
        this.ids=[]//初始化数据
        this.ids.push(val.id)
        this.$getToken.put(this.$API.Dodemands,this.$qs.stringify({
          ids:this.ids,
          handle:1
        },{indices:true})).then(res=>{
          this.$message.success("已处理成功")
          this.currentPage(this.pagenumber)
        }).catch(err=>{
          this.$message.error("处理失败，请刷新页面重试")
        })
      },
      //删除需求
      deleteMessage(val){
        this.ids=[]//初始化数据
        this.ids.push(val.id)
        this.$getToken.delete(this.$API.deleteDodemands,{
          params:{
            ids:this.ids
          }
        }).then(res=>{
          this.$message.success("已成功删除")
          this.currentPage(this.pagenumber)
        }).catch(err=>{this.$message.error("删除失败，请刷新页面重试")})
      },
      //批量删除需求
      deleteAllMessage(){
        this.$getToken.delete(this.$API.deleteDodemands,{
          params:{
            ids:this.ids
          }
        }).then(res=>{
          this.$message.success("已成功删除")
          this.currentPage(this.pagenumber)
        }).catch(err=>{this.$message.error("删除失败，请刷新页面重试")})
      }
    }
  }
</script>

<style scoped>
  .pagename {
    font-weight: bold;
    color: #333333;
    font-size: 20px;
    text-align: left;
  }

  .search {
    margin: 25px 0;
    display: flex;
  }

  label {
    font-size: 16px;
    color: #000;
    margin-right: 15px;
  }

  .button-box {
    margin-left: 15px;
  }

  .tips {
    text-align: left;
    color: #999999;
    font-size: 14px;
    margin: 12px 0;
  }

  .table-box {
    background: #fff;
    height: 70vh;
    padding: 2% 2% 1%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .from{
    height: 90%;
    overflow-y: auto;
  }

  .pagination {
    margin: 0 auto;
    margin-top: 20px;
    white-space: nowrap;
    padding: 2px 5px;
    color: #303133;
    font-weight: 700;
  }
</style>


// WEBPACK FOOTER //
// src/components/admin/adminmassage.vue